module.exports = __webpack_public_path__ + "img/blue.f8e1909.webp";